import { createFileRoute } from '@tanstack/react-router'
import { requireRole } from '@/lib/auth-guards'
import { ResellerSuspendedNumbersPage } from '@/features/reseller/pages/suspended-numbers'

export const Route = createFileRoute('/_authenticated/reseller/suspended-numbers')({
  beforeLoad: requireRole(['reseller', 'admin']),
  component: ResellerSuspendedNumbersPage,
})
